import prettyPrintKey from '../../scripts/pretty-print-key'
import prettyPrintValue from '../../scripts/pretty-print-value'
import datepicker from '../../components/js-datepicker'
import moment from 'moment'
import sort from 'array-sort'
import Filters from '../../scripts/filters'
import getContacts from '../../scripts/get-contacts'
import getAlerts from '../../../../assets-static/js/scripts/get-alerts'
import { isString } from 'underscore'

class History {

  constructor (container) {

    if(container) {

      this.container = container;
      this.section = container.querySelector('.account-content-section[data-for="history"]');

      this.isLoading = false;
      this.history = [];
      this.alerts = {};
      this.contacts = {};

      this.historyContainer = container.querySelector('.account-history-content');
      this.historyPagination = container.querySelector('.account-history-pagination');

      this.currentPage = 1;
      this.totalPages = 1;

      this.itemsPerPage = 10;

      this.filteredItems = [];
      this.filtered = {};
      this.$filters = $(container).find('.filters-list');
      this.$filterUsers = $(container).find('.filters-list-item[data-for="users"]');
      this.$filterDates = $(container).find('.filters-list-item[data-for="dates"]');

      this.Filters = new Filters(this.$filters, {
        onChange: (filtered) => {

          this.filtered = filtered;
          this.processHistoryItemsForFilters();

          this.currentPage = 1;
          this.renderHistory();
        },
      });

      this.filterDateStart = null;
      this.filterDateEnd = null;
      this.$filterDateStart = $(container).find('.history-filter__date__range-start');
      this.$filterDateEnd = $(container).find('.history-filter__date__range-end');

      this.bindActions();

    }

  }

  initDateInputs() {

    const startDate = window.datetimeToDate(this.history[this.history.length - 1].created);
    const endDate = window.datetimeToDate(this.history[0].created);

    this.$filterDateStart.val(moment(startDate).format('MM/DD/YYYY'));
    this.$filterDateEnd.val(moment(endDate).format('MM/DD/YYYY'));

    if(!this.filterDateStart) {
      this.filterDateStart = datepicker('.history-filter__date__range-start', {
        id: 'custom-range',
        minDate: startDate,
        formatter: (input, date, instance) => {
          input.value = moment(date).format('MM/DD/YYYY');
        },
      });
    }

    if(!this.filterDateEnd) {
      this.filterDateEnd = datepicker('.history-filter__date__range-end', {
        id: 'custom-range',
        maxDate: endDate,
        formatter: (input, date, instance) => {
          input.value = moment(date).format('MM/DD/YYYY');
        },
        position: 'br',
      });
    }

  }

  bindActions() {

    $(this.container).on('click', '.history-toggle-button', e => {

      const $btn = $(e.currentTarget);
      const id = $btn.data('for');
      const $icon = $btn.find('.history-toggle-button__icon');
      const $changeContainer = $(this.container).find(`.history-item-updated[data-for="${id}"]`);

      if($btn.hasClass('is-active')) {
        $btn.removeClass('is-active');
        $changeContainer.removeClass('is-active');
        $icon.html('<i class="far fa-plus-circle"></i>');
      } else {
        $btn.addClass('is-active');
        $changeContainer.addClass('is-active');
        $icon.html('<i class="far fa-minus-circle"></i>');
      }

    });

    $(this.historyPagination).on('click', '.pagination-item--previous', () => {

      if(this.currentPage > 1) {

        this.currentPage -= 1;
        this.renderHistory();

      }

    });

    $(this.historyPagination).on('click', '.pagination-item--next', () => {

      if(this.currentPage < this.totalPages) {

        this.currentPage += 1;
        this.renderHistory();

      }

    });

    $(this.historyPagination).on('click', '.pagination-item--page', e => {

      const $item = $(e.currentTarget);
      const targetPage = parseInt($item.data('for'));

      if(this.currentPage !== targetPage) {

        this.currentPage = targetPage;
        this.renderHistory();

      }

    });

  }

  processHistoryItemsForFilters() {

    this.filteredItems = [];

    if(this.history.length > 0) {

      this.history.forEach(item => {

        let isFiltered = false;

        if(this.filtered) {

          if(this.filtered.event && this.filtered.event.events) {

            const events = this.filtered.event.events;

            if(events.length > 0) {

              let matchedEvent = false;

              events.forEach(event => {
                if(item.event_type.match(event)) {
                  matchedEvent = true;
                }
              });

              if(!matchedEvent) {
                isFiltered = true;
              }

            }

          }

          if(this.filtered.users && this.filtered.users.users) {

            const users = this.filtered.users.users;

            if(users.length > 0) {

              let matchedUser = false;

              users.forEach(user => {
                if(item.user.email === user) {
                  matchedUser = true;
                }
              });

              if(!matchedUser) {
                isFiltered = true;
              }

            }

          }

          if(this.filtered.date) {

            let start = moment(this.filtered.date.date_start).format('YYYY-MM-DD') + ' 00:00:00';
            let end = moment(this.filtered.date.date_end).format('YYYY-MM-DD') + ' 23:59:59';

            start = moment(start).unix();
            end = moment(end).unix();

            let created = moment(window.datetimeToDate(item.created)).unix();

            if(start > created || end < created) {
              isFiltered = true;
            }

          }

        }

        if(!isFiltered) {
          this.filteredItems.push(item);
        }

      });

    }

    this.totalPages = Math.ceil(this.filteredItems.length / this.itemsPerPage);

    return this.filteredItems;

  }

  async loadHistory() {

    if(this.isLoading) {
      return;
    }

    this.isLoading = true;

    // loading animation
    this.historyContainer.innerHTML = `
      <div class="lite-list lite-list--loading">
        <div class="lite-list__header">
          <div class="lite-list__header__col" data-for="time">Time</div>
          <div class="lite-list__header__col" data-for="name">User</div>
          <div class="lite-list__header__col" data-for="event">Event</div>                   
        </div>
        <div class="lite-list__row"><div class="lite-list__row__col"></div></div>
        <div class="lite-list__row"><div class="lite-list__row__col"></div></div>
        <div class="lite-list__row"><div class="lite-list__row__col"></div></div>
        <div class="lite-list__row"><div class="lite-list__row__col"></div></div>
        <div class="lite-list__row"><div class="lite-list__row__col"></div></div>
        <div class="lite-list__row"><div class="lite-list__row__col"></div></div>
        <div class="lite-list__row"><div class="lite-list__row__col"></div></div>
        <div class="lite-list__row"><div class="lite-list__row__col"></div></div>
        <div class="lite-list__row"><div class="lite-list__row__col"></div></div>
        <div class="lite-list__row"><div class="lite-list__row__col"></div></div>
      </div>
    `;

    const contacts = await getContacts(true);

    this.contacts = {};

    // dictionary for contacts
    if(contacts && contacts.length > 0) {
      for(let contact of contacts) {
        this.contacts[contact.id] = contact;
      }
    }

    const alerts = await getAlerts(false);

    if(alerts) {
      this.alerts = alerts;
    } else {
      this.alerts = {};
    }

    const historyResults = await window.apiRequest('get', `/history`);

    this.isLoading = false;

    if(historyResults.type === 'success') {
      this.history = historyResults.data;
    }

    this.updateFilters();
    this.processHistoryItemsForFilters();
    this.renderHistory();

  }

  updateFilters() {

    this.initDateInputs();

    let users = [];

    this.history.forEach(item => {

      if(!users.includes(item.user.email)) {
        users.push(item.user.email);
      }

    });

    users = sort(users);
    const $usersList = this.$filterUsers.find('.filters-list-item-popout-list');

    if(users.length > 0) {

      let html = '';

      users.forEach(user => {
        html += `
        <label>
          <input type="checkbox" name="users[]" class="filter-user" value="${user}"> ${user}
        </label>
        `
      });

      $usersList.html(html);

    } else {
      $usersList.html('No users found');
    }

  }

  getEventName(item, data) {

    let event_name = '';

    switch(item.event_type) {
      case('alexa__alerts__disabled'):
        event_name = `Alerts <b>disabled</b> with Alexa Voice Command`;
        break;
      case('alexa__alerts__enabled'):
        event_name = `Alerts <b>enabled</b> with Alexa Voice Command`;
        break;
      case('alerts__test-alert'):
        event_name = `Alert <b>${data.alert.alert_name}</b> test sent`;
        break;
      case('alerts__create'):
        event_name = `Alert <b>${data.alert.alert_name}</b> created`;
        break;
      case('alerts__update'):
        event_name = `Alert <b>${data.alert.alert_name}</b> updated`;
        break;
      case('alerts__delete'):
        event_name = `Alert <b>${data.alert.alert_name}</b> deleted`;
        break;
      case('alerts__enabled'):

        let _alert = this.alerts[data.alert_id];

        if(_alert) {
          event_name = `Alert <b>${this.alerts[data.alert_id].alert_name}</b> ${data.enabled == 1 ? 'enabled' : 'paused'}`;
        } else {
          event_name = `Deleted alert <b>${data.alert_id}</b> ${data.enabled == 1 ? 'enabled' : 'paused'}`;
        }

        break;
      case('contacts__delete'):
        event_name = `Contact <b>${data.contact.contact_name}</b> deleted`;
        break;
      case('contacts__create'):
        event_name = `Contact <b>${data.contact.contact_name}</b> created`;
        break;
      case('contacts__update'):
        event_name = `Contact <b>${data.contact.contact_name}</b> updated`;
        break;
      case('sensors__update-wifi'):
        event_name = `Sensor <b>${data.sensor.sensor_name}</b> WiFi settings changed`;
        break;
      case('sensors__update'):
        event_name = `Sensor <b>${data.sensor.sensor_name}</b> updated`;
        break;
      case('sensors__sensor-moved-from-account'):
        event_name = `Sensor <b>${data.sensor.sensor_name}</b> moved from account`;
        break;
      case('sensors__sensor-moved-to-account'):
        event_name = `Sensor <b>${data.sensor.sensor_name}</b> added to account`;
        break;
      case('sensors__deleted'):
        event_name = `Sensor <b>${data.sensor.sensor_name}</b> deleted`;
        break;
      case('sensors__copy-readings'):
        event_name = `Sensor readings copied from <b>${data.from.sensor_name}</b> to <b>${data.to.sensor_name}</b>`;
        break;
      case('users__delete-sensor'):
        event_name = `Deleted sensor ${data.sensor.sensor_name}`;
        break;
      case('users__login'):
        event_name = 'User Login';
        break;
      case('users__change-password'):
        event_name = 'User password changed';
        break;
      case('users__login-updated'):
        event_name = `Login updated from <b>${data.old_email}</b> to <b>${data.new_email}</b>`;
        break;
      case('users__update-reports'):
        event_name = 'Reports Settings Changed';
        break;
      case('users__delete-all-events'):
        event_name = 'All account alerts / events deleted';
        break;
      case('users__promote-sub-user'):
        event_name = `<b>${data.new_primary.email}</b> was made the primary account`;
        break;
      case('users__delete-account'):
        event_name = `User deleted account`;
        break;
      case('sub-users__create'):
        event_name = `Sub user <b>${data.email}</b> created`;
        break;
      case('sub-users__delete-account'):
        event_name = `Sub user <b>${data.user.email}</b> deleted their account`;
        break;
      case('sub-users__delete'):
        event_name = `Sub user <b>${data.user.email}</b> deleted`;
        break;
      case('sub-users__set-read-only'):
        event_name = `Sub user <b>${data.user.email}</b> ${data.read_only == 1 ? 'set read only' : 'set as admin'}`;
        break;
      case('users__approve-enterprise-account-link'):
        event_name = `Enterprise link approved`;
        break;
      default:
        event_name = item.event_type;
        break;
    }

    return event_name;

  }

  renderHistory() {

    let html = `
    
    <div class="lite-list lite-list--notifications">
    `;

    const items = this.filteredItems;

    if(items.length > 0) {

      html += `
      <div class="lite-list__header">
        <div class="lite-list__header__col" data-for="time">Time</div>
        <div class="lite-list__header__col" data-for="name">User</div>
        <div class="lite-list__header__col" data-for="event">Event</div>       
      </div>
      `;

      const offset = (this.currentPage - 1) * this.itemsPerPage;

      let count = 0;

      for(let i = offset; i < items.length; i++) {

        if(count >= this.itemsPerPage) {
          break;
        }

        count++;

        let item = items[i];
        const data = JSON.parse(item.data);

        const created = window.getUserTimezoneDate(item.created);

        let event = '';
        let event_name = this.getEventName(item, data);

        let updated = null;
        let has_updates = false;

        if(data.updated && Object.keys(data.updated).length > 0) {

          has_updates = true;
          updated = '';

          Object.keys(data.updated).forEach(key => {

            let values = data.updated[key];

            const settingBefore = prettyPrintValue(values[0], key, data);
            const settingAfter = prettyPrintValue(values[1], key, data);

            // Handle when settings are turned off or turned on
            // otherwise show the change of value
            if(isString(settingBefore) && settingBefore.toLowerCase() === 'unset') {
              updated += `
              <div class="history-item-updated__item">
                <div class="history-item-updated__item__heading">${prettyPrintKey(key)}</div> 
                <div class="history-item-updated__item__updated-to">Enabled and set to</div>
                <div class="history-item-updated__item__after-value">${settingAfter}</div>
              </div>
              `;
            } else if(isString(settingAfter) && settingAfter.toLowerCase() === 'unset') {
              updated += `
              <div class="history-item-updated__item">
                <div class="history-item-updated__item__heading">${prettyPrintKey(key)}</div> 
                <div class="history-item-updated__item__updated-to">has been disabled</div>
              </div>
              `;
            } else {

              updated += `
              <div class="history-item-updated__item">
                <div class="history-item-updated__item__heading">${prettyPrintKey(key)}</div> 
                <div class="history-item-updated__item__before-value">${settingBefore}</div> 
                <div class="history-item-updated__item__updated-to">updated to</div>
                <div class="history-item-updated__item__after-value">${settingAfter}</div>
              </div>
              `;

            }

          });

        }

        let display_user = "";

        if(item.user && item.user.email) {
          if (item.user.email.startsWith("enterprise-admin@") && (item.user.email.match(/@/g) || []).length === 2) {
            display_user = item.user.email.replace("enterprise-admin@", "<span class='text--blue'>(Ent. Admin)</span> ");
          } else {
            display_user = item.user.email;
          }
        } else {
          display_user = `Removed sub user (${item.sub_name_id})`;
        }

        event = `
          
          ${has_updates ? `
          <button type="button" class="history-toggle-button" data-for="${item.id}">
          ` : ''}
          
            ${event_name}
         
          ${has_updates ? `
            <span class="history-toggle-button__icon"><i class="far fa-plus-circle"></i></span>
          </button>
          <div class="history-item-updated" data-for="${item.id}">
            ${updated}
          </div>
          ` : ''}
        `;

        html += `
        <div class="lite-list__row">
          <div class="lite-list__row__col" data-for="time">
            <span class="lite-list__row-label">Time:</span>
            ${created.format('MMM D, h:mm a')}
          </div>
          <div class="lite-list__row__col" data-for="user">
            <span class="lite-list__row-label">User:</span>
            ${display_user}
          </div>
          <div class="lite-list__row__col" data-for="event">
            <span class="lite-list__row-label">Event:</span>
            ${event}
          </div>
          
        </div>`;

      }

    } else {
      html += `
      <div class="lite-list__header">
        <div class="lite-list__header__col" data-for="time">Time</div>
        <div class="lite-list__header__col" data-for="name">User</div> 
        <div class="lite-list__header__col" data-for="event">Event</div>  
      </div>
      <div class="lite-list__row">
        No events found
      </div>
      `;
    }

    html += '</div>'; // end .lite-list

    this.historyContainer.innerHTML = html;

    this.renderPagination();

  }

  renderPagination() {

    let html = '';

    const items = this.history;

    if(items.length > 0) {
      html += `
        <div class="pagination">
          <button class="pagination-item pagination-item--previous ${this.currentPage === 1 ? 'disabled' : ''}">
            <i class="far fa-chevron-double-left"></i> Previous
          </button>
      `;

      for(let i = 1; i <= this.totalPages; i++) {

        if(i === 1 && this.currentPage !== 1) {
          html += `<button class="pagination-item pagination-item--page" data-for="1">1</button>`;

          if(this.currentPage - 2 > 1) {
            html += `<div class="pagination-item pagination-item--ellipses">...</div>`;
          }

        } else if(i === this.totalPages && this.totalPages !== this.currentPage) {

          if(this.currentPage + 2 < this.totalPages) {
            html += `<div class="pagination-item pagination-item--ellipses">...</div>`;
          }

          html += `<button class="pagination-item pagination-item--page" data-for="${this.totalPages}">${this.totalPages}</button>`;

        } else {

          if (this.currentPage === i) {
            html += `<button class="pagination-item pagination-item--current">${i}</button>`;
          } else {
            if (Math.abs(this.currentPage - i) < 3) {
              html += `<button class="pagination-item pagination-item--page" data-for="${i}">${i}</button>`;
            }
          }

        }

      }

      html += `
          <button class="pagination-item pagination-item--next ${this.currentPage === this.totalPages ? 'disabled' : ''}">
            Next <i class="far fa-chevron-double-right"></i>
          </button>
        </div>
      `;

    }

    this.historyPagination.innerHTML = html;

  }

}

export default History;
